window.u = navigator.userAgent;
window.ISIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export const imgArrList = [
  require('../images/bg.jpg'),
  require('../images/addPic.png'),
  require('../images/btn.png'),
  require('../images/con1.png'),
  require('../images/con2.png'),
  require('../images/con3.png'),
  require('../images/con4.png'),
  require('../images/con5.png'),
  require('../images/btn1.png'),
  require('../images/btn2.png'),
  require('../images/btn3.png'),
  require('../images/btn4.png'),
  require('../images/btn5.png'),
  require('../images/btn6.png'),
  require('../images/btn7.png'),
  require('../images/btn8.png'),
  require('../images/btn9.png'),
  require('../images/txt1.png'),
  require('../images/txt2.png'),
  require('../images/txt3.png'),
  require('../images/txt4.png'),
  require('../images/txt5.png'),
  require('../images/copyBtn.png'),
  require('../images/delete.png'),
  require('../images/rule_btn.png'),
  require('../images/rule_content.png'),
  require('../images/rule_text.jpg'),
  require('../images/tri.png'),
  require('../images/win1.png'),
  require('../images/win2.png'),
  require('../images/que.png'),
  require('../images/xiaopiao.png'),
];

export const mockSubmitInfo = [
  '*最新报名信息:王*   176****8535',
  '*最新报名信息:刘**  139****4427',
  '*最新报名信息:康*   180****6148',
  '*最新报名信息:牛**  139****4808',
  '*最新报名信息:谢**  155****1859',
  '*最新报名信息:曾**  134****4544',
  '*最新报名信息:赵**  136****7265',
  '*最新报名信息:李*   155****3266',
  '*最新报名信息:杨**  180****2364',
  '*最新报名信息:张*   136****5123',
  '*最新报名信息:吴**  176****1044',
  '*最新报名信息:钟**  134****1936',
  '*最新报名信息:裴**  150****0207',
  '*最新报名信息:王*  156****2903',
  '*最新报名信息:吴**  135****8049',
  '*最新报名信息:武**  175****3896',
  '*最新报名信息:马**  189****8168',
  '*最新报名信息:孙**  182****8899',
  '*最新报名信息:姚**  135****2030',
  '*最新报名信息:许**  136****5126',
  '*最新报名信息:李*  137****2086',
  '*最新报名信息:郑**  152****0080',
  '*最新报名信息:周*  159****1953',
  '*最新报名信息:郑**  156****4886',
  '*最新报名信息:王**  188****2008',
  '*最新报名信息:赫**  135****4454',
  '*最新报名信息:唐**  156****1175',
  '*最新报名信息:张**  150****6159',
  '*最新报名信息:谢**  136****8209',
  '*最新报名信息:冯**  134****0399',
  '*最新报名信息:吕**  138****6720',
  '*最新报名信息:罗**  139****8848',
  '*最新报名信息:刘**  188****9758',
  '*最新报名信息:袁**  139****7456',
  '*最新报名信息:马*  187****6898',
  '*最新报名信息:王**  186****2578',
  '*最新报名信息:周**  137****2814',
  '*最新报名信息:温**  150****8910',
  '*最新报名信息:徐**  139****0465',
  '*最新报名信息:章**  137****7204',
  '*最新报名信息:刘**  158****2904',
  '*最新报名信息:顾**  186****9882',
];
